/*
 * Newsletter / email-marketing popup — BubblegumSA
 * Logic ported from the AlCell email popup. Paired with
 * snippets/newsletter-popup.liquid + assets/newsletter-popup.css
 */
(function () {
  'use strict';

  var popup = document.getElementById('newsletter-popup');
  if (!popup) return;

  var LS = window.localStorage, SS = window.sessionStorage;
  var KEY_SUBSCRIBED = 'bgsaPopup:subscribed';
  var KEY_DISMISSED = 'bgsaPopup:dismissedAt';
  var KEY_SHOWN = 'bgsaPopup:shownThisSession';
  var KEY_UTM = 'bgsaPopup:utmSuppressed';
  var KEY_PV = 'bgsaPopup:pageviews';
  var KEY_NATIVE = 'bgsaPopup:pendingNativePost';

  var dialog = popup.querySelector('.newsletter-popup__dialog');
  var form = document.getElementById('newsletter-popup-form');
  var stepForm = popup.querySelector('[data-popup-step="form"]');
  var stepSuccess = popup.querySelector('[data-popup-step="success"]');
  var errorEl = popup.querySelector('[data-popup-error]');
  var delayMs = (parseInt(popup.dataset.delay, 10) || 10) * 1000;
  var suppressMs = (parseInt(popup.dataset.suppressDays, 10) || 14) * 864e5;
  var openTimer = null;
  var lastFocused = null;

  function safeGet(store, key) { try { return store.getItem(key); } catch (e) { return null; } }
  function safeSet(store, key, val) { try { store.setItem(key, val); } catch (e) {} }

  var search = window.location.search;

  // Suppress for the session when arriving from an email/SMS link.
  if (/utm_medium=(email|sms)/i.test(search)) safeSet(SS, KEY_UTM, '1');

  var pageviews = (parseInt(safeGet(SS, KEY_PV), 10) || 0) + 1;
  safeSet(SS, KEY_PV, String(pageviews));

  var subscribed = safeGet(LS, KEY_SUBSCRIBED) === '1';
  var dismissedAt = parseInt(safeGet(LS, KEY_DISMISSED), 10) || 0;
  var dismissedRecently = dismissedAt && (Date.now() - dismissedAt) < suppressMs;

  function showStep(stepEl, focusSel) {
    [stepForm, stepSuccess].forEach(function (s) { if (s) s.hidden = (s !== stepEl); });
    var f = focusSel && stepEl.querySelector(focusSel);
    if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
  }

  function openPopup(fromAuto) {
    if (openTimer) { clearTimeout(openTimer); openTimer = null; }
    lastFocused = document.activeElement;
    popup.hidden = false;
    document.body.classList.add('newsletter-popup-open');
    // Force the start-state to paint (display:none → flex), THEN add .is-open
    // on the next frame so the transition runs from the beginning. Double rAF
    // avoids the same-frame batch that would snap it open.
    void popup.offsetWidth;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { popup.classList.add('is-open'); });
    });
    if (fromAuto) safeSet(SS, KEY_SHOWN, '1');
    window.setTimeout(function () {
      var visibleStep = popup.querySelector('.newsletter-popup__step:not([hidden])');
      var target = visibleStep && visibleStep.querySelector('input, button');
      if (target) { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }
    }, 320);
    document.addEventListener('keydown', onKeydown);
  }

  function closePopup(opts) {
    opts = opts || {};
    popup.classList.remove('is-open');
    document.body.classList.remove('newsletter-popup-open');
    document.removeEventListener('keydown', onKeydown);
    window.setTimeout(function () { popup.hidden = true; }, 280);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    if (subscribed) return; // on the list — never re-show
    if (opts.dismiss) safeSet(LS, KEY_DISMISSED, String(Date.now()));
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { closePopup({ dismiss: true }); return; }
    if (e.key !== 'Tab') return;
    // Focus trap.
    var focusables = dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])');
    var visible = Array.prototype.filter.call(focusables, function (el) { return el.offsetParent !== null; });
    if (!visible.length) return;
    var first = visible[0], last = visible[visible.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  popup.querySelectorAll('[data-newsletter-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { closePopup({ dismiss: true }); });
  });
  var overlay = popup.querySelector('[data-newsletter-close-overlay]');
  if (overlay) overlay.addEventListener('click', function () { closePopup({ dismiss: true }); });

  // Email capture → success.
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      form.classList.add('is-loading');
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'text/html' }
      }).then(function (resp) {
        // Shopify confirms a successful signup by redirecting back with
        // ?customer_posted=true — only treat that as success.
        if (resp.ok && resp.url.indexOf('customer_posted=true') !== -1) {
          subscribed = true;
          safeSet(LS, KEY_SUBSCRIBED, '1');
          showStep(stepSuccess, 'button');
          return;
        }
        // Anything else (400/403 bot-protection rejections of XHR posts,
        // "Verifying your connection..." interstitials, etc.): fall back to a
        // native full-page post — Shopify's standard flow handles those for
        // real users. The pending flag reopens the popup straight on the
        // success step after the redirect back.
        safeSet(SS, KEY_NATIVE, '1');
        form.submit();
      }).catch(function () {
        if (errorEl) errorEl.hidden = false;
      }).finally(function () {
        form.classList.remove('is-loading');
      });
    });
  }

  var copyBtn = popup.querySelector('[data-popup-copy]');
  if (copyBtn) {
    var copyIcon = copyBtn.innerHTML;
    var checkIcon = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
    var copyRevert = null;
    copyBtn.addEventListener('click', function () {
      var codeEl = popup.querySelector('[data-popup-code]');
      var code = codeEl ? codeEl.textContent.trim() : '';
      if (navigator.clipboard && code) {
        navigator.clipboard.writeText(code).then(function () {
          copyBtn.innerHTML = checkIcon;
          if (copyRevert) clearTimeout(copyRevert);
          copyRevert = window.setTimeout(function () { copyBtn.innerHTML = copyIcon; }, 2000);
        });
      }
    });
  }

  // ── Decide what to do on this pageview ──

  // Theme editor: always show so the merchant can style it.
  if (window.Shopify && window.Shopify.designMode) { openPopup(false); return; }

  // Recover from the native captcha fallback: the popup form posted via a
  // full-page submit, Shopify's challenge redirected back here. Show success.
  if (safeGet(SS, KEY_NATIVE) === '1') {
    try { SS.removeItem(KEY_NATIVE); } catch (e) {}
    if (search.indexOf('customer_posted=true') !== -1) {
      subscribed = true;
      safeSet(LS, KEY_SUBSCRIBED, '1');
      showStep(stepSuccess, null);
      openPopup(false);
      return;
    }
  }

  if (subscribed) return;
  if (safeGet(SS, KEY_UTM) === '1' || dismissedRecently || safeGet(SS, KEY_SHOWN) === '1') return;
  // 2nd+ pageview: open almost immediately; 1st pageview: wait out the delay.
  openTimer = window.setTimeout(function () { openPopup(true); }, pageviews >= 2 ? 1500 : delayMs);
})();
